"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
exports.__esModule = true;
var utils_1 = __importDefault(require("@blaze-react/utils"));
var react_1 = __importStar(require("react"));
var Checkbox_1 = __importDefault(require("./Checkbox"));
exports.Checkbox = Checkbox_1["default"];
var CheckBoxes = function (_a) {
    var returnBoolean = _a.returnBoolean, onChangeCheckboxList = _a.onChange, options = _a.options, error = _a.error, validationMessage = _a.validationMessage, name = _a.name, _b = _a.utils, ErrorMessage = _b.ErrorMessage, uniqueId = _b.uniqueId, full = _a.full, attrs = __rest(_a, ["returnBoolean", "onChange", "options", "error", "validationMessage", "name", "utils", "full"]);
    var formatedOptions = Array.isArray(options) ? options : [options];
    var _c = react_1.useState(formatedOptions), data = _c[0], setData = _c[1];
    react_1.useEffect(function () { return setData(formatedOptions); }, [options]);
    var onChange = function (_a) {
        var value = _a.value;
        if (value.disabled) {
            return;
        }
        var currentIndex = data.findIndex(function (_a) {
            var id = _a.id;
            return id === value.id;
        });
        if (currentIndex < 0) {
            return;
        }
        data[currentIndex].checked = value.checked;
        setData(__spreadArrays(data));
        var currentValues = data.filter(function (_a) {
            var checked = _a.checked;
            return checked;
        });
        if (returnBoolean) {
            currentValues = !!currentValues.length;
        }
        onChangeCheckboxList({
            data: data,
            event: { target: { name: name } },
            value: currentValues
        });
    };
    return (react_1["default"].createElement(react_1["default"].Fragment, null,
        data.map(function (_a, key) {
            var _b = _a.checked, checked = _b === void 0 ? false : _b, disabled = _a.disabled, id = _a.id, label = _a.label, checkboxName = _a.name, required = _a.required, _c = _a.show, show = _c === void 0 ? true : _c, value = _a.value;
            return show ? (react_1["default"].createElement(Checkbox_1["default"], { full: full, key: id || uniqueId(name), onChange: onChange, checked: checked, disabled: disabled, id: id, label: label, name: checkboxName, required: required, show: show, value: value, "data-cy": attrs["data-cy"]
                    ? attrs["data-cy"] + "-checkbox-cy-" + (key + 1)
                    : "checkbox-cy-" + (key + 1), testId: attrs["test-id"] || "checkbox-" + (key + 1) })) : null;
        }),
        error && react_1["default"].createElement(ErrorMessage, { message: validationMessage })));
};
CheckBoxes.defaultProps = {
    error: false,
    full: false,
    options: [],
    returnBoolean: false,
    validationMessage: "This field is required"
};
var Checkboxes = utils_1["default"](CheckBoxes);
exports.Checkboxes = Checkboxes;
